import { leftColumnWidth, outsideWrapperId, screenWidthMultiplier } from "../constants";

export const getCanvasWidth = () => {
  const wrapperWidth = document.getElementById(outsideWrapperId)?.clientWidth || 0;
  const width = (wrapperWidth - leftColumnWidth) * screenWidthMultiplier + 150;
  return width < 1400 ? 1400 : width;
};
